import {
  ROOM_TYPE_FILTER,
  ROOM_TYPE_SPECIFIC,
} from "@Pages/Search/components/FilterSection/data/filtersList";
import RadioChip from "../RadioChip";
import styles from "./roomType.module.scss";
import { FilterComponentProps } from "@Pages/Search/components/FilterSection/components/ActiveFilterComponent/types";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";

const RoomType = ({ value = [], dispatch }: FilterComponentProps<string[]>) => {
  const handleSelectedValue = (val: string) => {
    gtagEventEmitter({
      action: "SP_filter_subsection_filter_value_selected",
      category: "SP_filter_subsection",
      value: "Room Type",
    });
    dispatch({ type: "roomType", payload: [val] });
  };
  const filters = [...ROOM_TYPE_FILTER.list, ...ROOM_TYPE_SPECIFIC.list];
  const { t } = useTranslationHook();
  return (
    <div className={styles.roomTypeContainerFilterSubsection}>
      {filters.map((filter) => (
        <RadioChip
          key={filter.name}
          name="roomType"
          label={t(filter.name)}
          value={filter.value}
          isSelected={value.includes(filter.value)}
          setSelectedValue={handleSelectedValue}
        />
      ))}
    </div>
  );
};

export default wrapperHOC(RoomType, {
  componentName: "RoomType-FilterSubsection-SearchListDesktop-SearchPage",
  showForChina: true,
});
